import axios, { AxiosResponse } from "axios";
import { IBankAccountModel } from "./BankAccountModel";
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const BANK_ACCOUNT_CREATE_URL = `${API_URL}api/v1/definition/bankAccount/create`;
export const BANK_ACCOUNT_GET_ALL_URL = `${API_URL}api/v1/definition/bankAccount/all`;
export const BANK_ACCOUNT_DELETE_URL = `${API_URL}api/v1/definition/bankAccount/delete/`;
export const BANK_ACCOUNT_UPDATE_URL = `${API_URL}api/v1/definition/bankAccount/update/`;


export function createBankAccount(BankAccountId: IBankAccountModel) {
  return axios.post(BANK_ACCOUNT_CREATE_URL, BankAccountId)
}

export function updateBankAccount(BankAccountId: IBankAccountModel) {
  return axios.patch(BANK_ACCOUNT_UPDATE_URL , BankAccountId)
}

export function deleteBankAccount(BankAccountId: number | string) {
  return axios.delete(BANK_ACCOUNT_DELETE_URL +BankAccountId)
}

export async function getAllBankAccounts(
  page = 0, 
  size = 10, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IBankAccountModel>>>> {
  return axios.get(BANK_ACCOUNT_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}